(function ($) {
  $(window).on('load', function () {
    initPhotoSwipeFromDOM('.gallery');
    var resizeId;

    function doneResizing() {
      $('.gallery.grid-h').GridHorizontal({
        item: '.item',
        minWidth: $(window).width()>991?200:100,
        maxRowHeight: $(window).width()>991?250:150,
        gutter: $(window).width()>991?30:15,
      });
    }
    doneResizing();
    $(window).resize(function () {
      clearTimeout(resizeId);
      resizeId = setTimeout(doneResizing, 500);
    });
  });
})($);